import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getApiBase, resolveAsset } from "../utils/paths";

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const backendBase = getApiBase().replace(/\/backend\/api$/, '/backend');
  if (path.startsWith('/backend/uploads/')) return `${backendBase}${path.replace(/^\/backend/, '')}`;
  if (path.startsWith('/uploads/')) return `${backendBase}${path}`;
  return path.startsWith('/') ? `${backendBase}${path}` : `${backendBase}/${path}`;
};

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✨ Animation for job cards
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
      },
    },
  };

  // 🔹 Fetch jobs from backend (public careers)
  useEffect(() => {
    (async () => {
      try {
        const apiBase = getApiBase();
        const res = await fetch(`${apiBase}/public/careers.php`);
        if (!res.ok) throw new Error('Unable to load careers');
        const data = await res.json();
        if (data.items) setJobs(data.items);
      } catch (err) {
        console.error('Error fetching jobs:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <Header />

      {/* Page Header Section */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: `url(${resolveAsset('/assets/images/backgrounds/career.png')})`,
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src={resolveAsset('assets/images/shapes/page-header-shape1.png')} alt="" />
        </div>
        <div className="shape2">
          <img src={resolveAsset('assets/images/shapes/page-header-shape2.png')} alt="" />
        </div>
        <div className="container">
          <div className="page-header__inner">
            <motion.h2
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              Career
            </motion.h2>
          </div>
        </div>
      </section>

      {/* Job List Section */}
      <div className="container my-5">
        <div className="row">
          <div className="col-12 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Latest <span className="text-primary">Featured Jobs</span>
            </motion.h2>
          </div>
        </div>

        <div className="row justify-content-center mt-4">
          {loading ? (
            <p className="text-center">Loading job openings...</p>
          ) : jobs.length === 0 ? (
            <p className="text-center">No job openings available right now.</p>
          ) : (
            jobs.map((job) => (
              <motion.div
                key={job.id}
                className="card my-4 mx-auto shadow"
                style={{ width: "25rem", borderRadius: "15px" }}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                {job.logo_path && (
                  <img
                    src={resolveImage(job.logo_path)}
                    className="card-img-top"
                    alt={job.title}
                    style={{
                      height: "180px",
                      objectFit: "contain",
                      padding: "10px",
                    }}
                  />
                )}
                <div className="card-body">
                  <h5 className="card-title">{job.title}</h5>
                  <h6 className="card-subtitle mb-2 text-muted">
                    {job.office_location} | Deadline: {job.last_date}
                  </h6>
                  <ul className="list-unstyled">
                    <li>
                      <strong>Salary:</strong> Negotiable
                    </li>
                    <li>
                      <strong>Experience:</strong> {job.year_of_passing || 'Fresher Can apply'} years
                    </li>
                    <li>
                      <strong>Qualification:</strong> {job.qualification}
                    </li>
                    <li>
                      <strong>Location:</strong> {job.office_location}
                    </li>
                  </ul>

                  <Link
                    to={`/job/${job.id}`}
                    className="vh-donate-btn"
                    style={{
                      marginTop: '1rem',
                      textDecoration: 'none',
                      width: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    Apply Now
                  </Link>
                </div>
              </motion.div>
            ))
          )}
        </div>
      </div>

      <Footer />

      {/* Scroll to top button */}
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text">Go Back Top</span>
      </a>
    </>
  );
};

export default Career;
